import React from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash-es';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { Link } from 'site-modules/shared/components/link/link';

export function RankingsSegmentList({ displayName = '', segmentRatings = [] }) {
  return (
    <section>
      <h3 className="size-16 fw-medium">Best {displayName}</h3>
      <ol>
        {sortBy(segmentRatings, 'rank').map(({ baseStyleId, modelYear }) => (
          <li key={`${baseStyleId}-${displayName}`} className="size-16 ps-0_5 mb-0_25">
            <Link to={getCoreUrl(modelYear)} rel="nofollow">
              {modelYear.year} {modelYear.makeName} {modelYear.modelName}
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}

RankingsSegmentList.propTypes = {
  displayName: PropTypes.string,
  segmentRatings: PropTypes.arrayOf(PropTypes.shape({})),
};

export function RankingsSummaryLists({ type = 'Car', vehicleEditorialRankings = [] }) {
  const beforeCollapse = vehicleEditorialRankings.slice(0, 1);
  const insideCollapse = vehicleEditorialRankings.slice(1);

  return (
    <div className="rankings-summary-list text-gray-darker">
      <h2 className="heading-3">Best {type}s Summary</h2>
      {beforeCollapse.map(segment => (
        <RankingsSegmentList {...segment} key={segment.displayName} />
      ))}
      <ContentCollapse
        textClosed="Read more"
        textOpen="Read less"
        justify="justify-content-start"
        btnContainerClasses="m-0 p-0"
        btnClasses="p-0 size-16 text-primary-darker more-info-btn"
        btnTextClasses="fw-normal"
        showBtnBelow
      >
        {insideCollapse.map(segment => (
          <RankingsSegmentList {...segment} key={segment.displayName} />
        ))}
      </ContentCollapse>
    </div>
  );
}

RankingsSummaryLists.propTypes = {
  vehicleEditorialRankings: PropTypes.arrayOf(TypeRankingsEntities.VehicleRanking),
  type: PropTypes.string,
};
